import { render } from "./InstallWizardLayoutCard.vue?vue&type=template&id=1a4c864c"
import script from "./InstallWizardLayoutCard.vue?vue&type=script&lang=js"
export * from "./InstallWizardLayoutCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__